/**
     * @desc 上传图片
所有图片上传接口，返回图片在线地址
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, form, options = {}) {
  return ajax.post('/files/uploadFile', params);
}

export function upload(params, form, options = {}) {
  return ajax.upload('/files/uploadFile', params);
}
